/**
 * Web stub for react-native-otp-entry
 */
import React, { FC } from 'react';

interface OtpInputProps {
  numberOfDigits?: number;
  onTextChange?: (text: string) => void;
  onFilled?: (text: string) => void;
  focusColor?: string;
  focusStickBlinkingDuration?: number;
  [key: string]: any;
}

const OtpInput: FC<OtpInputProps> = ({
  numberOfDigits = 6,
  onTextChange,
  onFilled,
  focusColor = '#007AFF',
  ...props
}) => {
  const [value, setValue] = React.useState('');

  const handleChange = (e: any) => {
    const val = (e.target.value || '').replace(/[^0-9]/g, '').slice(0, numberOfDigits);
    setValue(val);
    onTextChange?.(val);
    if (val.length === numberOfDigits) {
      onFilled?.(val);
    }
  };

  return React.createElement('input', {
    type: 'text',
    inputMode: 'numeric',
    maxLength: numberOfDigits,
    value,
    onChange: handleChange,
    style: {
      width: '100%',
      padding: '12px',
      fontSize: '24px',
      textAlign: 'center',
      border: `2px solid ${focusColor}`,
      borderRadius: '8px',
      letterSpacing: '8px',
      ...props.style,
    },
  });
};

export { OtpInput };
export default OtpInput;
